import frUtils from '../util/frUtils';

(function ($) {

    $.fn.modal = function () {

        this.each((i, el) => {
            const $self = $(el);
            const modal = new window.Modal($self[0]);
            let $modalId = $self.attr('id');

            $self.on('fr:showModal', () => {
                modal.show();
            });

            $self.on('fr:hideModal', () => {
                modal.hide();
            });

            // Remove url hash
            let $modal = document.getElementById($modalId);
            $modal.addEventListener('hidden.bs.modal', function () {
                frUtils.removeUrlHash();
                $self.trigger('fr:afterHideModal');
            });

            //modal popup close
            $($modal).on('click', '.close', function () {
                modal.hide();
            });

        });

        return this;
    }

    $(() => {
        $('.modal').modal();
    });

})($);


// WEBPACK FOOTER //
// ./scripts/modules/modal.js